import { NgModule } from '@angular/core';
import { FooterComponent } from '@shared/component/layout/footer/footer.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    FooterComponent
  ],
  exports: [
    FooterComponent
  ]
})
export class FooterModule { }
